/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_StatusInputs */

const en_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const fr_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const it_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato`)
};

const ru_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус`)
};

const es_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const zh_cn2_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

const ja_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const hi_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const pt_pt2_invoice_status = /** @type {(inputs: Invoice_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Invoice_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoice_status = /** @type {((inputs?: Invoice_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_invoice_status(inputs)
	if (locale === "de") return de_invoice_status(inputs)
	if (locale === "it") return it_invoice_status(inputs)
	if (locale === "ru") return ru_invoice_status(inputs)
	if (locale === "es") return es_invoice_status(inputs)
	if (locale === "zh-CN") return zh_cn2_invoice_status(inputs)
	if (locale === "ja") return ja_invoice_status(inputs)
	if (locale === "hi") return hi_invoice_status(inputs)
	if (locale === "pt-PT") return pt_pt2_invoice_status(inputs)
	return en_invoice_status(inputs)
});